var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ios-fullscreen-gif-animation",on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":_vm.gifAnimationPath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }